// extracted by mini-css-extract-plugin
export default {"OTTLogoWithText":"fhzex","logoImage":"BK6ig","skeleton-progress":"-ivto"};